// @ts-nocheck
import useGetCurrentProduct from "@store/Framework/Store/Foundation/Data/Products/ProductsHooks/useGetCurrentProduct";
import { DetailModel } from "@insite/client-framework/Types/ApiModels";
import constants from "@store/constants";

export default () => {
    const {
        product: { detail },
    } = useGetCurrentProduct();

    const defaultValue = {
        roundingRule: "",
        multipleSaleQty: 1,
    };

    const { roundingRule, multipleSaleQty } = (detail as DetailModel) ? (detail as DetailModel) : defaultValue;
    const isMultipleOnly = roundingRule === constants.roundingRulesTypes.multipleOnly;

    return { roundingRule, multipleSaleQty, isMultipleOnly };
};
